<ng-container *ngIf="profileField$ | async as profileField">
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="labelIcons"></sh-field-label>
    </dt>
    <dd class="sh-description-list__details" *ngIf="value$ | async as value; else suggestions">
        <med-thesaurus-concept [conceptReference]="value" [thesaurusFieldDefinition]="profileField.FieldDefinition"></med-thesaurus-concept>
    </dd>
</ng-container>

<ng-template #suggestions>
    <dd class="sh-description-list__details" *ngIf="suggestion$ | async as suggestion; else empty">
        <i class="sh-icon-label" style="margin-left: 0">
            <span>{{ suggestion }}</span>
            <span class="sh-icon-label__icon -sh-superscript" style="margin-left: 2px" [title]="'thesaurus.suggestion-not-approved' | translate">
                <svg sh-icon [size]="'small'" aria-hidden="true" [name]="'info'"></svg>
            </span>
        </i>
    </dd>
</ng-template>

<ng-template #empty>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
